const pictureSelector = '[data-banner-picture]';
const headerSelector = '[data-banner-header]';
const titleSelector = '[data-banner-title]';
const subtitleSelector = '[data-banner-subtitle]';
const acceptedImageLanguages = ['fr', 'de', 'es', 'en'];
const defaultImageLanguage = 'en';
const titleKey = 'mobile.banner.full.body.$$.title';
const subtitleKey = 'mobile.banner.full.body.$$.subtitle';

Hop.requireMessage('mobile.banner.full.*');

Hop.defineModule('mobile-banner-full', (root, params) => {
    const $root = $(root);
    const $closeButton = $root.find('[data-dismiss]');
    const defaultStyleConfiguration = 'dashboard';
    const styleParameter = params.styleChoice || defaultStyleConfiguration;
    const languageToSelect = params.language || 'en';

    const styleConfiguration = {
        profile: {
            picture: '//dam.malt.com/rebranding2020/mobile/profile_$$',
        },
        dashboard: {
            picture: '//dam.malt.com/rebranding2020/mobile/dashboard_$$',
        },
        mission: {
            picture: '//dam.malt.com/rebranding2020/mobile/mission_$$',
        },
        messenger: {
            picture: '//dam.malt.com/rebranding2020/mobile/messenger_$$',
        },
    };

    function init() {
        setupHeader();
        setupImage();
        setupTitles();

        if (isMobile()) {
            $('#freelancer-app-banner-full').modal('show');
            if (window.heap) {
                window.heap.track(`download-mobile-app-${styleParameter}-open`);
            }
        }
        registerListener();
    }

    function setupHeader() {
        $(headerSelector).addClass(`freelancer-app-banner-full__container-content-header-${styleParameter}`);
    }

    function setupImage() {
        const adjustedImageWidth = Math.floor(window.innerWidth / 2.28);

        const languageToUse = chooseImageLanguage(languageToSelect);
        const newImageUrl = styleConfiguration[styleParameter].picture.replace('$$', languageToUse);
        $(pictureSelector).attr('src', `${newImageUrl}?w=${adjustedImageWidth}`);
    }

    function setupTitles() {
        const newTitleKey = titleKey.replace('$$', styleParameter.toUpperCase());
        const newSubtitleKey = subtitleKey.replace('$$', styleParameter.toUpperCase());
        $(titleSelector).text(Hop.message(`${newTitleKey}`));
        $(subtitleSelector).text(Hop.message(`${newSubtitleKey}`));
    }

    function chooseImageLanguage(lang) {
        if (acceptedImageLanguages.includes(lang)) {
            return lang;
        }

        return defaultImageLanguage;
    }

    function isMobile() {
        return window.matchMedia('(max-width:767px)').matches;
    }

    function deleteNotification() {
        if (window.heap) {
            window.heap.track(`download-mobile-app-${styleParameter}-close`);
        }

        fetch(`/profile/mobile/notification`, {method: 'DELETE'});
    }

    function registerListener() {
        $closeButton.on('click', deleteNotification);
    }

    function deregisterListener() {
        $closeButton.off('click', deleteNotification);
    }

    init();

    return function destroy() {
        deregisterListener();
    };
});
